import React from 'react';
import { motion } from 'framer-motion';
import { AlertOctagon } from 'lucide-react';
export function CostOfInaction() {
  const costs = [{
    situation: 'Años sintiéndote estancado sin saber exactamente por qué',
    cost: 'Tiempo que no vuelve'
  }, {
    situation: 'Creencias de escasez heredadas que corren en piloto automático',
    cost: 'Decisiones que te cuestan dinero y oportunidades todos los días'
  }, {
    situation: 'Sin herramientas para regular el estado emocional',
    cost: 'Relaciones dañadas. Trabajo afectado. Salud comprometida.'
  }, {
    situation: 'Sin sistema de vínculos',
    cost: 'Red que drena en lugar de potenciar tu crecimiento'
  }, {
    situation: 'Sin dirección de propósito clara',
    cost: 'Energía dispersa. Esfuerzo enorme sin resultado visible.'
  }, {
    situation: 'La misma respuesta ante el mismo contexto',
    cost: 'El próximo año exactamente igual que este'
  }];
  return <section className="py-20 md:py-32 px-4" data-id="element-57">
      <div className="max-w-4xl mx-auto" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-59">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-60">
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-61">
          {costs.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-6 rounded-xl" data-id="element-62">
              <div className="flex items-start gap-3 mb-4" data-id="element-63">
                <AlertOctagon className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-64" />
                <p className="text-gray-300 font-medium" data-id="element-65">{item.situation}</p>
              </div>
              <div className="bg-dark p-4 rounded-lg border border-dark-border/50" data-id="element-66">
                <span className="text-red-400 font-bold text-sm uppercase tracking-wider block mb-1" data-id="element-67">
                  Costo real:
                </span>
                <span className="text-white" data-id="element-68">{item.cost}</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-69">
          <p className="text-xl md:text-2xl text-gray-300 mb-8" data-id="element-70">
            El contexto argentino no va a esperarte. Pero vos podés elegir desde
            dónde lo atravesás.
          </p>
          <div className="inline-block bg-gradient-to-r from-gold/20 via-gold/10 to-gold/20 border border-gold/30 rounded-2xl p-8" data-id="element-71">
            <p className="text-2xl md:text-3xl font-heading font-bold text-gold-light italic" data-id="element-72">
              "El único contexto que realmente podés cambiar es el que tenés
              adentro." <span className="not-italic" data-id="element-73">🧠</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}